export const SCREEN_READER_ANNOUNCER_ID = 'screen-reader-announcer';
export const SCREEN_READER_ASSERTIVE_ID = 'screen-reader-announcer-assertive';

function getLiveRegionConfig(priority) {
  if (priority === 'assertive') {
    return {
      id: SCREEN_READER_ASSERTIVE_ID,
      role: 'alert',
      live: 'assertive',
    };
  }

  return {
    id: SCREEN_READER_ANNOUNCER_ID,
    role: 'status',
    live: 'polite',
  };
}

export function ensureScreenReaderLiveRegion(priority = 'polite') {
  if (typeof document === 'undefined') {
    return null;
  }

  const { id, role, live } = getLiveRegionConfig(priority);
  let region = document.getElementById(id);
  if (!region) {
    region = document.createElement('div');
    region.id = id;
    region.className = 'sr-only';
    region.setAttribute('role', role);
    region.setAttribute('aria-live', live);
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
  }

  return region;
}

export function announceToScreenReader(message, priority = 'polite') {
  const text = (message || '').replace(/\s+/g, ' ').trim();
  if (!text) {
    return;
  }

  const region = ensureScreenReaderLiveRegion(priority);
  if (!region) {
    return;
  }

  region.textContent = '';
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      region.textContent = text;
    });
  });
}

export function getVuejsDialogMessage(container) {
  if (!container) {
    return '';
  }

  const messageNode =
    container.querySelector('.dg-content-body') ||
    container.querySelector('.dg-content') ||
    (container.classList && container.classList.contains('dg-main-content')
      ? container
      : container.querySelector('.dg-main-content'));

  return messageNode ? messageNode.textContent : '';
}



// WEBPACK FOOTER //
// ./src/utils/screenReaderAnnounce.js